import { Assignment, VisibilityOutlined } from '@mui/icons-material';
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { Card, Col, Input, Modal, Row } from "antd";
import SpinLoader from "components/Loader/SpinLoader";
import Loading from "components/Loading";
import OverAllGraph from "components/PlacementExam/OverAllGraph";
import { cloneDeep, filter, find, get, isEmpty } from "lodash";
import moment from "moment-timezone";
import { usePlacementExamList } from "store/placement_exam/selectors";
import { handleGetOverallAverage } from "store/placement_exam/thunks";
import { useStandards } from "store/story/selectors";
import { handleUpdateStanders } from "store/story/thunks";
import styled from "styled-components";
import color from "utils/constants/color";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import {
  Button as ButtonUpdate,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tab,
  Tabs,
  TextareaAutosize,
  TextField,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import SentryWrap from 'components/Sentry';


//  -- Components ---------------------


//  -- Constants ----------------------

//  -- Thunks -------------------------












import * as Sentry from '@sentry/react';
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
const BORDERCOLOR = [
  "rgb(200,109,152)",
  "rgb(146,158,227)",
  "rgb(80,233,200)",
  "rgb(238,206,151)",
];
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const StableWrapper = styled.div`
      width: 100%;
      overflow-x: auto;
      //   @media (max-width: 992px) {
      //     padding:24px 0px;
      //   }
    `;
const StableWrapperMain = styled.div``;

const FilterContainer = styled.span`
      font-size: 17px;
      font-weight: 500;
      cursor: pointer;
    `;

const TextAreaAuto = styled(TextareaAutosize)`
      height: 200px;
      max-height: 210px;
      width: 100%;
      border-radius: 2px;
      padding: 5px;
      overflow: hidden;
      border-color: rgb(0 0 0 / 32%);
      ::focus-visible {
        outline: #03989e 1px !important;
        border: 5px solid red !important;
      }
      ::focus {
        border-color: #03989e !important;
      }
    `;
  const StyledModal = styled(Modal)`
      width: 85% !important;
    
      @media (max-width: 1024px) {
        width: 85% !important;
      }
    
      @media (max-width: 768px) {
        width: 96% !important;
      }
    
      .ant-modal-content {
        display: flex;
        flex-direction: column;
      }
    
     .ant-modal-header {
        position: sticky;
        top: 0;
        z-index: 1000; /* Ensure it appears above other content */
        background: white;
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px; /* Ensure close button has enough space */
      }

      .ant-modal-close {
        position: absolute;
        right: 16px;
        z-index: 1001; /* Higher z-index for visibility */
      }
  `;

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: '4px',
  },
}));
const StanderForm = ({ standers, onChangeStanders }) => {
  const [standerData, setStanderData] = useState(null);
  const [error, setError] = useState(null);
  const allStanderds = useStandards();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (standers) {
      setStanderData(standers);
    }
  }, [standers]);

  const onUpdate = async () => {
    if (!standerData.abbr) {
      setError("Abbreviation is required");
      return;
    } else if (!standerData.description) {
      setError("Description is required");
      return;
    } else if (!standerData.grade_level) {
      setError("Grade level is required");
      return;
    }
    const hasAllReady = find(
      allStanderds,
      (std) =>
        std.id != standerData.id &&
        standerData.abbr.toLowerCase() == std.abbr.toLowerCase()
    );
    if (hasAllReady) {
      setError("Abbreviation is already taken");
      setTimeout(() => {
        setError(null);
      }, 5000);
      return;
    }
    setError(null);
    setLoader(true);
    await dispatch(handleUpdateStanders(standerData));
    setLoader(false);
    onChangeStanders();
  };
  const onChangeData = (key, value) => {
    const res = cloneDeep(standerData);
    res[key] = value;
    setStanderData(res);
  }
  return (
    <div>
      <Row gutter={[15, 15]}>
        <Col xs={24} lg={24}>
          {/* <Card> */}
          <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
            <Col xs={24} lg={24}>
              <TextField
                id="title"
                name="title"
                label="Abbreviation"
                InputLabelProps={{ shrink: true }}
                type="text"
                variant="outlined"
                onChange={(e) => {
                  onChangeData("abbr", e.target.value);
                }}
                value={get(standerData, "abbr", "")}
              />
            </Col>
            <Col xs={24} lg={24} className="floatingLabelBG">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="type">Grade Level</InputLabel>
                <TextField
                  id="grade_level"
                  name="grade_level"
                  label="Grade Level"
                  InputLabelProps={{ shrink: true }}
                  type="text"
                  variant="outlined"
                  onChange={(e) => {
                    onChangeData("grade_level", e.target.value);
                  }}
                  value={get(standerData, "grade_level", "")}
                />
              </FormControl>
            </Col>
            <Col xs={24} lg={24}>
              <FormControl variant="outlined">
                <InputLabel
                  id="textTip"
                  style={{
                    backgroundColor: "#fff",
                    paddingLeft: 2,
                    paddingRight: 2,
                  }}
                >
                  Discrptions
                </InputLabel>
                <TextAreaAuto
                  id="hypelink"
                  name="hypelink"
                  label="Discrptions"
                  InputLabelProps={{ shrink: true, required: true }}
                  type="text"
                  variant="outlined"
                  onChange={(e) => {
                    onChangeData("description", e.target.value);
                  }}
                  value={get(standerData, "description", "")}
                  style={{ height: 80, borderRadius: 4, overflow: "scroll" }}
                />
              </FormControl>
            </Col>
          </Row>
        </Col>
      </Row>
      {error ? (
        <FormHelperText error>
          {error}
        </FormHelperText>
      ) : null}
      <Row
        gutter={[24, 24]}
        style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
      >
        <ButtonUpdate
          onClick={onUpdate}
          color="primary"
          variant="contained"
          disabled={!standerData || loader}
          style={{ minWidth: 200 }}
        >
          {loader ? <Loading white size={14} /> : "Update"}
        </ButtonUpdate>
      </Row>
    </div>
  );
};

const PlacementExamDistrictList = ({ userloading }) => {
    const showAlert = useAlert();
  const placementExamList = usePlacementExamList()
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = React.useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [loader,setLoader] = useState(false);
  const [overAllData, setOverAllData] = useState({});
  const [openOverAllModal, setOpenOverAllModal] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState({});
  const [statusTab, setStatusTab] = useState('active');
  const [searchText, setSearchText] = useState('');

  const filteredStanders = useMemo(() => {
    const byArchive = filter(placementExamList, (x) =>
      statusTab === 'archive' ? !!x.is_archived : !x.is_archived
    );
    if (searchText && searchText.length >= 1) {
      const q = searchText.toLowerCase();
      return filter(byArchive, (x) =>
        `${x.displayName || ''}`.toLowerCase().includes(q)
      );
    }
    return byArchive;
  }, [placementExamList, statusTab, searchText]);

  const onSearch = (event) => {
    setSearchText(event.target.value || '');
  };

  const onStatusTabChange = (_, value) => {
    setStatusTab(value);
    setPage(0);
  };

  const getExamAveg = async (code) => {
    try {
      setLoader(true)
      setOverAllData({})
      const data = await handleGetOverallAverage(code)
      if (data && data.success) {
        setOverAllData(data.data)
        setOpenOverAllModal(true)
      } else {
        if (data && data.data == 'no_submission') {
          showAlert("No submission found", "error")
        } else if (data && data.data == 'no_exam') {
          showAlert("No exam found", "error")
        }
        else {
          showAlert("Something went wrong", "error")
        }
      }
    } catch (error) {
      Sentry.captureException(`443 Error in getExamAveg: ${error}`);
    } finally {
      setLoader(false)
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const onExamViewSubmission = (exam_id,exam_code) => {
    navigate(`/placement_exam_submissions?exam_id=${exam_id}&exam_code=${exam_code}`)
  };
  return (
    <SentryWrap>
      <SpinLoader dataloader={loader} />
      <StableWrapperMain>
        <FilterContainer className="FilterHeading">
          <Card type="inner" title="Filters">
            <Row gutter={[0, 12]}>
              <Col xs={24} lg={24} md={24}>
                <Tabs
                  value={statusTab}
                  onChange={onStatusTabChange}
                  textColor="primary"
                  indicatorColor="primary"
                >
                  <Tab label="Active" value="active" />
                  <Tab label="Archive" value="archive" />
                </Tabs>
              </Col>
              <Col xs={24} lg={24} md={24} className="ColCardPadding">
                <Card style={{ width: "100%" }}>
                  <Input
                    placeholder="Search by name"
                    bordered={false}
                    style={{ height: "32px" }}
                    onChange={onSearch}
                  />
                </Card>
              </Col>
            </Row>
          </Card>
        </FilterContainer>
        <StableWrapper>
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{
              width: "100%",
              textAlign: "center",
              backgroundColor: "#fff",
              marginTop: 20,
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                >
                  Display Name
                </TableCell>
                <TableCell
                  style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                >
                  Duration
                </TableCell>
                <TableCell
                  style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                >
                  Assigned on
                </TableCell>
                <TableCell
                  style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                >
                  Exam Code
                </TableCell>
                <TableCell
                  style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                >
                  Status
                </TableCell>
                <TableCell
                  style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                >
                  View Submissions
                </TableCell>
                <TableCell
                  style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                >
                  View Overall
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(filteredStanders) &&
                (userloading ? (
                  <Loading size={30} />
                ) : (
                  <TableRow key={"0"} style={{ border: 0 }}>
                    <TableCell colSpan={7} style={{ textAlign: "center" }}>
                      No results
                    </TableCell>
                  </TableRow>
                ))}
              {!isEmpty(filteredStanders) &&
                filteredStanders
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow
                        key={row.id}
                        style={{
                          "&:lastChild td, &:lastChild th": { border: 0 },
                        }}

                      >
                        <TableCell>
                          {" "}
                          {row && row.displayName ? row.displayName : '-'}
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: BORDERCOLOR[0],
                          }}

                        >
                          {row && row.duration > 0 ? `${row.duration} minutes` : '-'}
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: BORDERCOLOR[0],
                            maxWidth: 380,
                          }}
                          onClick={() => { }}
                        >
                          {row && row.assigned && row.assigned && row.assigned.assigned_on ? moment(row.assigned.assigned_on).format('YYYY-MM-DD') : '-'}
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            maxWidth: 380,
                          }}
                        >
                          {row && row.assigned && row.assigned.assignment_code ? row.assigned.assignment_code : '-'}
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: row?.is_archived
                              ? color.gray100
                              : row?.assigned?.status
                                ? color.green100
                                : color.red,
                            maxWidth: 380,
                          }}
                        >
                          {row?.is_archived
                            ? 'Archived'
                            : row?.assigned?.status
                              ? 'Active'
                              : 'Deactivated'}
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            maxWidth: 380,
                            paddingLeft:50
                          }}

                        >
                          <IconButton style={{ padding: 0 , margin:"auto" }}
                            onClick={() => {
                              onExamViewSubmission(row.id, row?.assigned?.assignment_code)
                            }}
                          >
                            <Assignment color="primary" style={{ color: color.green100 }} />
                          </IconButton>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            maxWidth: 380,
                            paddingLeft:50
                          }}
                        >
                          <IconButton style={{ padding: 0  ,  margin:"auto"}} onClick={() => {
                            setSelectedAssignment(row)
                            getExamAveg(row?.assigned?.assignment_code)
                          }}>
                            <VisibilityOutlined color="primary" style={{ color: color.green100 }} />
                          </IconButton>

                        </TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
            <TableFooter>
              <TableRow>
                {!isEmpty(filteredStanders) && (
                  <TablePagination
                    count={filteredStanders.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    backIconButtonProps={{
                      color: "secondary",
                    }}
                    nextIconButtonProps={{ color: "secondary" }}
                  />
                )}
              </TableRow>
            </TableFooter>
          </Table>
        </StableWrapper>
      </StableWrapperMain>
      <StyledModal
            footer={null}
            title={selectedAssignment&&selectedAssignment.displayName?selectedAssignment.displayName:'Overall view'}
            centered
            open={openOverAllModal}
            destroyOnHidden={true}
            onOk={() => setOpenOverAllModal(false)}
            onCancel={() => setOpenOverAllModal(false)}
            bodyStyle={{ padding: 8 }}
            className="FilterHeading placementQstnModal 122"
          >
            <OverAllGraph  overAllData={overAllData||{}} />
          </StyledModal>
    </SentryWrap>
  );
};


export default PlacementExamDistrictList;